import { CloudOff, Schedule, Warning } from '@tempo-io/sui-icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useTranslation } from 'react-i18next';
import type { ActualCostCompletenessStatus } from '@/common/api/types/itemFinancials';

export const ActualCostStatusIndicator = ({
  status,
  testId = 'actual-cost-status-indicator',
}: {
  status: ActualCostCompletenessStatus | null | undefined;
  testId?: string;
}) => {
  const { t } = useTranslation();
  if (status == null || status === 'COMPLETE') return null;

  const { Icon, label, colorClassName } =
    status === 'INCOMPLETE'
      ? {
          Icon: Warning,
          label: t(($) => $.financials.actualCostStatus.incomplete),
          colorClassName: 'text-icon-warning',
        }
      : status === 'PRESERVED'
        ? {
            Icon: Schedule,
            label: t(($) => $.financials.actualCostStatus.preserved),
            colorClassName: 'text-icon-info',
          }
        : {
            Icon: CloudOff,
            label: t(($) => $.financials.actualCostStatus.unavailable),
            colorClassName: 'text-icon-error',
          };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            className="inline-flex shrink-0 items-center justify-center"
            data-testid={testId}
          >
            <Icon aria-hidden="true" className={`size-3.5 ${colorClassName}`} />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
